export * from './api.service';
export * from './auth-guard.service';
export * from './privilege-guard.service';
export * from './jwt.service';
export * from './tags.service';
export * from './user.service';
export * from './caregiver.service';
export * from './patient.service';
export * from './modal.service';
export * from './validate.service';
export * from './date.service';
export * from './notification.service';
export * from './socket.service';



// WEBPACK FOOTER //
// ./src/app/shared/services/index.ts